import { MatRadioModule } from '@angular/material/radio';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from 'src/app/core/_config/missingTranslationHandler';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomListComponent } from './custom-list/custom-list.component';
import { SearchPersonInputComponent } from './search-person-input/search-person-input.component';
import { MonthDatePickerComponent } from './month-date-picker/month-date-picker.component';
import { LoaderComponent } from './loader/loader.component';
import { DialogCustomComponent } from './dialog-custom/dialog-custom.component';
import { SimpleListComponent } from './simple-list/simple-list.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { YearDatePickerComponent } from './year-date-picker/year-date-picker.component';
import { MaterialModule } from './material/material.module';

@NgModule({
  entryComponents: [DialogCustomComponent],
  imports: [
    NgbModule,
    TranslateModule.forChild({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
      useDefaultLang: false
    }),
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  exports: [
    CustomListComponent,
    SearchPersonInputComponent,
    MonthDatePickerComponent,
    LoaderComponent,
    DialogCustomComponent,
    SimpleListComponent,
    CustomSelectComponent,
    YearDatePickerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  declarations: [
    CustomListComponent,
    SearchPersonInputComponent,
    MonthDatePickerComponent,
    LoaderComponent,
    DialogCustomComponent,
    SimpleListComponent,
    CustomSelectComponent,
    YearDatePickerComponent
  ]
})
export class ComponentsModule { }
